import { render, staticRenderFns } from "./TicketItemOffers.vue?vue&type=template&id=201b746f&"
import script from "./TicketItemOffers.vue?vue&type=script&lang=js&"
export * from "./TicketItemOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports